module.exports = __webpack_public_path__ + "static/media/kaltbach_cave.cc3a8c06.jpg";